import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8531b1a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 충전희망금액 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 현재 보유 금액 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 충전 가능 금액 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 충전 신청 되었어요! ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 아래 계좌로 입금을 완료해주세요 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 입금 계좌 복사하기 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 입금 코드 복사하기 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 입금통장 표시내용 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 에 꼭 입력해주세요 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 입금코드 누락시 예수금이 충전되지 않습니다 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" * 전자금융 사기 피해 방지를 위해 충전된 예수금은 충전일로부터 24시간이 지난 후 출금이 가능합니다. ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 취소 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 충전신청 ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 신청 취소 ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 닫기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_keypad = _resolveComponent("keypad")!
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_content, null, {
      default: _withCtx(() => [
        (_ctx.componentNumber === 1)
          ? (_openBlock(), _createBlock(_component_ag_box_s, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box_s, { css: {
          mt:'10px',
          mb:'16px',
          textAlign:'center',
        } }, {
                  default: _withCtx(() => [
                    (!_ctx.depositAmount)
                      ? (_openBlock(), _createBlock(_component_ag_text_s, {
                          key: 0,
                          css: {
            dp:'block',
            mb:'20px',
            color:'gray6',
          },
                          class: "price-font"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_1
                          ]),
                          _: 1
                        }))
                      : (_ctx.depositAmount)
                        ? (_openBlock(), _createBlock(_component_ag_text_s, {
                            key: 1,
                            class: "price-font",
                            css: {
            dp:'block',
            mb:'20px',
            color: _ctx.depositAmount>_ctx.availableDeposit?'red2':''
          }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.currency(_ctx.depositAmount)), 1),
                              _hoisted_2
                            ]),
                            _: 1
                          }, 8, ["css"]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_ag_box_s, { css: {
            dp:'flex',
            displayDirection:'row',
            px:'20px',
            justifyContent:'space-between',
            typography:'text14r',
            marginBottom:'8px',
            color:'gray3',
          } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, null, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_text_s, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.currentBalance)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box_s, { css: {
            dp:'flex',
            px:'20px',
            justifyContent:'space-between',
            typography:'text14r',
            marginBottom:'8px',
            color:'gray3',
          } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, null, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_text_s, { css: {
              color:'primary',
            } }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.availableDeposit)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_keypad, {
                  "model-value": _ctx.depositAmount,
                  type: _ctx.openTypeRef,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.inputFunc($event)))
                }, null, 8, ["model-value", "type"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.componentNumber === 2)
          ? (_openBlock(), _createBlock(_component_ag_box_s, {
              key: 1,
              css: {
        dp:'flex',
        direction:'column',
        alignItems:'center',
        textAlign:'center',
        px:'20px',
      }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_img, {
                  width: "38px",
                  height: "38px",
                  margin: "20px 0px",
                  src: "/assets/image/small_check.png"
                }),
                _createVNode(_component_ag_box_s, { css: {
          mb:'24px'
        } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text_s, { css: {dp:'block', typography:'tit24r'} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {typography:'num24eb'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.depositInfo.amount)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text_s, { css: {dp:'block', typography:'tit20r'} }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text_s, { css: {dp:'block', typography:'text16r', color:'gray3'} }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_ag_box_s, {
                  css: {
          dp: 'flex',
          direction: 'column',
          alignItems: 'center',
          padding: '16px',
          border:'1px solid #222222',
          borderRadius:'8px',
          width:'100%',
          mb:'4px',
        },
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'예수금 충전/출금 정보', 'clickContent':'입금 계좌 복사'}); })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {typography:'tab16b', mb:'4px'} }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box_s, { css: {typography:'text12r', color:'gray3'} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`${_ctx.depositInfo.bank} ${_ctx.depositInfo.bankno} ${_ctx.depositInfo.bankholder}`) + " " + _toDisplayString(), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_directive_clipboard, `${_ctx.depositInfo.bank} ${_ctx.depositInfo.bankno} ${_ctx.depositInfo.bankholder}`, "copy"],
                  [_directive_clipboard, _ctx.onSuccess, "success"],
                  [_directive_clipboard, _ctx.onError, "error"]
                ]),
                _withDirectives(_createVNode(_component_ag_box_s, {
                  css: {
          dp: 'flex',
          direction: 'column',
          alignItems: 'center',
          padding: '16px',
          border:'1px solid #FD6767',
          borderRadius:'8px',
          width:'100%',
        },
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'예수금 충전/출금 정보', 'clickContent':'입금 코드 복사'}); })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {typography:'tab16b', mb:'4px', color:'red2'} }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box_s, { css: {typography:'text12r', color:'gray3'} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.depositInfo.depositCode), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box_s, { css: {typography:'text14r', color:'red2'} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {typography:'tit14b'} }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }),
                        _hoisted_11,
                        _createVNode(_component_ag_text_s, { css: {dp:'block'} }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_directive_clipboard, _ctx.depositInfo.depositCode, "copy"],
                  [_directive_clipboard, _ctx.onSuccessCode, "success"],
                  [_directive_clipboard, _ctx.onError, "error"]
                ]),
                _createVNode(_component_ag_box_s, { css: {
          borderRadius:'4px',
          width:'100%',
          color:'primary',
          bg:'#F6F8FB',
          mt:'16px',
          p:'8px',
          typography:'btn12r',
          textAlign:'left',
        } }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ag_footer, {
      p: "20px",
      mb: "safeAreaBottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box_s, { css: {
        dp:'flex',
        gap:'sp6'
      } }, {
          default: _withCtx(() => [
            (_ctx.componentNumber === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ag_button, {
                    corner: "10px",
                    outline: "primary",
                    width: "100%",
                    onClickCapture: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`취소`});_ctx.cancel()})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_button, {
                    corner: "10px",
                    disabled: _ctx.checkDisable,
                    width: "100%",
                    onClickCapture: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`다음`});_ctx.requestDeposit()})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ], 64))
              : (_ctx.componentNumber === 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_ag_button, {
                      corner: "10px",
                      outline: "primary",
                      width: "100%",
                      onClickCapture: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`신청 취소`});_ctx.cancelDepositConfirm()})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_button, {
                      corner: "10px",
                      disabled: _ctx.checkDisable,
                      width: "100%",
                      onClickCapture: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`닫기`});_ctx.closeModal()})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ], 64))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}